import api from "../utils/api";
const API_URL = process.env.REACT_APP_API_URL + "/skillNotes.php";

export const getNotesBySkill = async (skill_id) => {
  const res = await api.post(API_URL, {
    action: "getBySkill",
    skillId: skill_id,
  });
  return res.data.notes;
};

export const addNote = async (note) => {
  const res = await api.post(API_URL, { ...note, action: "add" });
  return res.data;
};

export const deleteNote = async (id) => {
  const res = await api.post(API_URL, { action: "delete", id });
  return res.data;
};
